<main class="main-start">
  <div class="head-background"></div>
  <div class="head">
    <h1 class="sr-only" i18n="sr-only@@verify.title">Willkommen auf der CléA Assistenzplattform</h1>
    <img aria-hidden="true" src="/assets/images/illustration-registration.svg">
  </div>

  <form [formGroup]="form" class="content">
    <div>
      <p class="text" i18n="@@verify.content">
                Wir haben eine Verifikationsnummer an Ihre E-Mail-Adresse geschickt, um Ihre E-Mailadresse zu prüfen.
                Bitte geben Sie die erhaltene Verifikationsnummer in das unten stehende Feld ein.<br>
                Falls Sie die E-Mail nicht erhalten haben, prüfen Sie bitte auch den Spam-Ordner.
            </p>
    </div>
    <div class="row">
      <div class="col-left">
        <div [hidden]="isLoading$ | async" class="form-group">
          <label class="label" for="input-verification-code" i18n="@@verify.input.verificationCode">Verifikationsnummer
                        aus E-Mail</label>
          <input class="input large" formControlName="verificationCode" id="input-verification-code"
            type="string">
          @if (verificationCodeControl.invalid && (verificationCodeControl.touched || verificationCodeControl.dirty)) {
            <div
              class="validation error" i18n="@@verify.error.verificationCode">Bitte geben Sie die 6-stelligen
                        Verifikationsnummer ein.
                    </div>
          }
        </div>
        <app-spinner [visible]="isLoading$ | async"></app-spinner>
      </div>
      <div class="col-right">
        <div class="form-group">
          <button (click)="verifyEnrollment()" [disabled]="(isLoading$ | async) || !form.valid"
            class="button primary large block" i18n="@@verify.btn.verifyEnrollment">
                        Bestätigen
                    </button>
        </div>
      </div>
    </div>
    <div>
      <button (click)="requestVerificationCode()" class="link" i18n="@@verify.btn.requestVerificationCode"
        type="button">Verifikationsnummer erneut anfordern
            </button>
    </div>
  </form>
</main>
